import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SmoothScroll } from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import WorkCatalog from "@/pages/WorkCatalog";
import WorkPostDetail from "@/pages/WorkPostDetail";
import ProjectDetail from "@/pages/ProjectDetail";
import Studio from "@/pages/Studio";
import Contact from "@/pages/Contact";
import InstagramTrial from "@/pages/InstagramTrial";
import InstagramTrialDetail from "@/pages/InstagramTrialDetail";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <SmoothScroll>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WorkCatalog />} />
          <Route path="/ai-films" element={<WorkCatalog defaultAiOnly />} />
          <Route path="/film/:shortcode" element={<WorkPostDetail />} />
          <Route path="/demo-showcase" element={<Home />} />
          <Route path="/work/:slug" element={<ProjectDetail />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/instagram-trial" element={<InstagramTrial />} />
          <Route path="/instagram-trial/:shortcode" element={<InstagramTrialDetail />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </SmoothScroll>
  );
}

export default App;
